import { Component, OnInit } from '@angular/core';
import { DashboardService } from "./dashboard.service";
import { PredictionsService } from "../predictions/predictions.service";

import { ListPredictions } from '../../classes/ListPredictions';
import { Prediction } from '../../classes/Prediction';

// groups
import { PredictionGroup } from '../../classes/PredictionGroup';

import { GroupsService } from "../groups/groups.service";
import { GroupsPipe } from "../../common/filters/groups.filter";
import { RemoveSpaceBetweenPipe } from "../../common/filters/removewhitespacebetween.filter";

import { kconfig } from '../../globals';

import 'datatables.net'
declare let swal:any;
declare let $:any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  public leaderboard: any;

  predictions: ListPredictions;
  predictionDetails: Prediction;
  public serial:string       = '';
  public nickname:string       = '';

  public tableWidget: any;
  public selectedName: string="";

  private teams: any;
  private groups: any; 


  constructor(private _groupsService: GroupsService, private _dashboardService: DashboardService, private _predictionsService: PredictionsService) { }

  ngOnInit() {
    this.getLeaderboard();
    this.getGroups();
    this.getTeams();
  }

  getPredictionDetails(serial:any,nickname:string){
    this.serial = serial ;
    this.nickname = nickname;
    let data = {
      'serial':serial
    };
    // Get Predictions Data
    this._predictionsService
    .GetPredictionDetails(data)
    .subscribe(getPredictionDetails => {
      this.predictionDetails = getPredictionDetails.data;
    });
  
    
    $('#tab-2').addClass('animated slideInRight');
    $('a[href="#tab-2"]').tab('show');
  }

  getLeaderboard(){
    this._dashboardService
    .getLeaderboard()
    .subscribe(leaderboard => {
      this.leaderboard = leaderboard;
      //this.initDatatable();
    });
  }

  getCalcGroupPoints(){
    this._dashboardService
    .getCalcGroupPoints()
    .subscribe(group_points => {
      //this.group_points = group_points;
      //this.initDatatable();
      this.getLeaderboard();
    });
  }

  ngAfterViewInit() {
  }


  private initDatatable(): void {
    let table_el: any = $('#example');
    this.tableWidget = table_el.DataTable({
      select: true,
      columnDefs: [{
        targets: -1,
        data: this.leaderboard,
        defaultContent: '<button class="ver-button btn btn-info waves-effect" (click)="getPredictionDetails(serial_id,nickname)">Ver &nbsp;<i class="zmdi zmdi-eye"></i></button>',
      }],
      data: this.leaderboard,
      columns: [
          { title: '#', data:  'row_id' },
          { title: 'Nickname', data: 'nickname' },
          { title: 'Points Matches', data: 'points_matches' },
          { title: 'Points Groups', data: 'points_groups' },
          { title: '' },
      ],
    });
 
 //   $('#example')
 //     .removeClass('display')
 //     .addClass('table table-striped table-bordered')
  }

  private reInitDatatable(): void {
    if (this.tableWidget) {
      this.tableWidget.destroy();
      this.tableWidget=null
    }
    setTimeout(() => this.initDatatable(),0)
  }


  public selectRow(index: number, row:any) {
    this.selectedName = "row#" + index + " " + row.name
  }

  ShowAlert(title:string, msg:string, type:string){
      swal({
         title: title,
         text: msg , 
         type: type
      });
  }

  // Groups Section
  getTeams(){
    this._groupsService
    .getTeams()
    .subscribe(teams => {
      this.teams = teams;
    })
  }

  getGroups(){
    this._groupsService
    .getGroups()
    .subscribe(groups => {
      this.groups = groups;
    })
  }

  getGroupsBySerial(serial){
    // Ajax call to save groups
    $.ajax({
        url: kconfig.apiUrl + "controller.predictions.php?accion=GetPredictionGroupDetails",
        type: "POST",
        dataType: "json",
        data: {
            serial: serial
        },
        beforeSend: function() {				
          //jQuery('.gift-shop-main').html('<div class="loader"></div>');
        },
        success: function(data) {
          //clear all the value
          $('.group_selector').each(function( index, value ) {
            $(value).removeClass('second selected');
            $(value).html("");
            $(value).removeClass('first selected');
            console.log('cleaning');
          });
            $(data.data).each(function( index, value ) {
              // map new values.
              $.map( value, function( value, index ) {
                  var team  = value;
                  var group = index.substring(0, 1);
                  var place = index.substring(1, 2);
                  //console.log(value+ " "+ group + " " + place);
                  if (team > 0 && team != "")
                  {
                    if (place == 1)
                    {
                      $('*[data-team-id="'+team+'"]').addClass("first selected");
                      $('*[data-team-id="'+team+'"]').html("1")
                    }
                    else if (place == 2)
                    {
                      $('*[data-team-id="'+team+'"]').addClass("second selected");
                      $('*[data-team-id="'+team+'"]').html("2")
                    }
                  }
              });
              
              // var $this = $(value);
              // var id = $this.data('team-id');
              // console.log(id);
              // if (id == data.data.A1)
              // {
              //   $this.addClass("first selected");
              //   $this.html("1");
              // }
            });
        },
        complete: function () { 
              
        }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.component.ts